export default __webpack_public_path__ + "static/media/dt5.5e54793e.webp";